import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M64.994 68.386a2.283 2.283 0 0 0 .089-.438V15.7a8.344 8.344 0 0 0-8.335-8.34h-13.5a8.344 8.344 0 0 0-8.331 8.34v52.248a2.307 2.307 0 0 0 .1.477 2.4 2.4 0 0 0 .175 1.581l9.217 18.378c1.945 3.664 4.392 4.256 5.767 4.256h.142c1.31-.038 3.765-.659 5.431-4.313L64.83 70a2.4 2.4 0 0 0 .164-1.614zm-11.589 13.58h-6.713L40.9 70.41h18.232zm6.754-16.48H39.841V29.669h20.318zm-16.907-53.2h13.5a3.416 3.416 0 0 1 3.407 3.414v9.051H39.841V15.7a3.416 3.416 0 0 1 3.411-3.416z'

const IconPencil: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} viewBox="0 0 100 100" />
)

export default IconPencil
